let clockOffsetMs = 0;

export function getServerNow(): Date {
  return new Date(Date.now() + clockOffsetMs);
}

export function setClockOffset(serverTs: number, clientTs = Date.now()): void {
  clockOffsetMs = serverTs - clientTs;
}

export function getClockOffset(): number {
  return clockOffsetMs;
}

export function resetClockOffset(): void {
  clockOffsetMs = 0;
}

export async function syncServerClock(): Promise<number> {
  try {
    const { healthCheck } = await import('../firebase/FunctionsService');
    const before = Date.now();
    const res = (await healthCheck()) as { ts?: number };
    const after = Date.now();
    const serverTs = typeof res?.ts === 'number' ? res.ts : after;
    const midpoint = before + Math.floor((after - before) / 2);
    setClockOffset(serverTs, midpoint);
    return clockOffsetMs;
  } catch {
    resetClockOffset();
    return 0;
  }
}
